const {Component} = require("react");
const managerApi = require("app/pipelines/checkout/manager");
const ProductCart = require("app/components/checkout/carts/ProductCart");
const env = require("app/services/env");
const hashParams = require("app/util/hashParams");
const Trans = require('app/components/trans/Trans');

class Manager extends Component {

	constructor(props) {
		super(props);

		this.state = {
			active: null
		};
	}

	componentDidMount() {
		managerApi.open.capture(payload => {
			this.setState({active: payload.cart});
			return payload;
		});

		managerApi.close.capture(payload => {
			this.setState({active: null});
			return payload;
		});

		managerApi.toggle.capture(payload => {
			return this.state.active === payload.cart ?
				managerApi.close.dispatch(payload) :
				managerApi.open.dispatch(payload);
		});

		// Open cart if instructed by hash
		let hash = hashParams();

		if (hash.indkobskurv) {
			managerApi.open.dispatch({cart: "product"});
		}

		let url = new URL(window.location)
		
		if (url.searchParams.get('showcart') === "true") {
			managerApi.open.dispatch({cart: "product"});
		}

	}

	close = (e) => {
		this.setState({active: null});
	}

	isActive(name) {
		return this.state.active === name;
	}

	renderCarts() {
		if (env.server()) {
			return;
		}

		return (
			<div className="carts">
				<div className="keep-shopping" onClick={this.close}><Trans>Forsæt med at shoppe</Trans></div>
				<ProductCart open={this.isActive("product")}/>
			</div>
		);
	}

	render() {
		return (
			<div className="checkout-manager">{this.renderCarts()}</div>
		);
	}

}

module.exports = Manager;
